import { useEffect } from 'react';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

var useLockBodyScroll = function useLockBodyScroll(toggle, targetRef) {
  useEffect(function () {
    var targetElement = targetRef.current;

    if (!toggle || !targetElement) {
      return;
    }

    disableBodyScroll(targetElement);
    return function () {
      return enableBodyScroll(targetElement);
    };
  }, [targetRef, toggle]);
};

export { useLockBodyScroll };